import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { useDefaultComponentValue } from '../../../utils/useDefaultComponentValue';
const COMPONENT_NAME = 'CalendarHeading';
const CalendarHeading = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { date = moment().locale('cs') } = props;
    return /*#__PURE__*/ React.createElement("div", {
        className: "DatePickerHeader"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "DatePickerHeader-heading"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "DatePickerHeader-date"
    }, date.clone().format('D'), "."), /*#__PURE__*/ React.createElement("span", {
        className: "DatePickerHeader-day"
    }, date.clone().format('dddd'))));
};
CalendarHeading.propTypes = {
    date: PropTypes.any
};
export default CalendarHeading;
